import { Component, Input, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-content-display',
  templateUrl: './content-display.component.html',
  styleUrls: ['./content-display.component.css']
})
export class ContentDisplayComponent {

  constructor() { }

  @Input() modalRef: NgbModalRef;
  @Input() text: string;
  @Input() title: string;

  close(){
    this.modalRef.close();
  }
}
